































































































import { Vue, Component } from 'vue-property-decorator';
import Role from '@/userManagement/Role';
import RoleType from '@/userManagement/RoleType';
import PerTableComp from '@/components/PerTableComp.vue';
import Typekey from '@/userManagement/Typekey';
import { COLLECTION_ROLES } from '@/model/AppConstants';
@Component({
  components: {
    PerTableComp,
  },
})
export default class Roles extends Vue {
  dialog = false;
  dialogDelete = false;
  show = false;
  deletedItem = {} as any;
  headers = [
    {
      text: 'Code',
      align: 'start',
      value: 'roleType.code',
    },
    { text: 'Name', value: 'roleType.name' },
    { text: 'Description', value: 'roleType.description' },
    { text: 'Actions', value: 'actions' },
  ];
  mounted() {
    this.$store.dispatch('bindRole');
  }
  get roles() {
    return this.$store.state.roles;
  }
  roledefaultObj = {
    code: '',
    name: '',
    description: '',
  }
  openPer = (item: any) => {
    this.$store.commit('setPermissions', item);
  }
  roleObj = { ...{}, ...this.roledefaultObj }
  editedItem = {
    name: '',
    calories: 0,
    fat: 0,
    carbs: 0,
    protein: 0,
  };
  defaultItem = {
    name: '',
    calories: 0,
    fat: 0,
    carbs: 0,
    protein: 0,
  };
  deleteItem(item: any) {
    this.deletedItem = item;
    this.dialogDelete = true;
  }
  deleteItemConfirm() {
    this.$store.dispatch('removeFromCollection', {
      collection: COLLECTION_ROLES,
      payload: this.deletedItem.id,
    });
    this.closeDelete();
  }
  close() {
    this.dialog = false;
    this.roleObj.code = '';
    this.roleObj.name = '';
    this.roleObj.description = '';
  }
  closeDelete() {
    this.dialogDelete = false;
  }
  save() {
    const Obj = new RoleType(this.roleObj.code, this.roleObj.name, this.roleObj.description);
    const role = new Role({ ...Obj });
    this.$store.dispatch('addToCollection', {
      collection: COLLECTION_ROLES,
      doc: Obj.code,
      payload: { ...role },
    });
    this.close();
  }
}
